export default __webpack_public_path__ + "static/media/uncertified.d9331a89.svg";